<!--
 * @Author: QWX
 * @Description:对账结算凭证
 * @LastEditors: QWX
 * @LastEditTime: 2021-11-11 15:35:09
-->
<template>
  <zl-dialog class="zl-saas voucher-common-dialog" title="查看凭证" ref="dialog" width="1200px" :close-on-click-modal="false">
    <div class="common-btns">
      <el-button icon="iconfont icon-xiazai" type="primary" @click="downloadArrivalOrder" :disabled="!src">下载</el-button>
    </div>
    <div class="common-content" v-loading="loading">
      <zsPdf
        v-if="src"
        :src="src"
      />
    </div>
  </zl-dialog>
</template>
<script>
import store from '@/store'
import zsPdf from '../zsPdf.vue'
import config from '@/config/config'
export default {
  components: {
    zsPdf
  },
  data() {
    return {
      src: '', // 预览PDF的url
      loading: false
    }
  },
  methods: {
    async previewElectronicOrder() {
      let fileId
      this.loading = true
      await store.dispatch('downloadAccountCert', {
        accountId: this.accountId
      })
        .then(res => {
          fileId = res
        })
      const result = await this._util.getFileToken(2, 1, fileId)
      this.loading = false
      this.src = `${config.fileDownUrl}/zsj-file-server/token/downloadFile?guid=${fileId}&token=${result}`
    },
    downloadArrivalOrder() {
      window.open(this.src)
    },
    async open(args) {
      this.accountId = args.accountId
      this.previewElectronicOrder()
      return this.$refs.dialog.open()
    },
    cancel() {
      this.$refs.dialog.cancel()
    }
  }
}
</script>
<style lang="scss">
@import '@/assets/css/voucher.scss';

</style>
<style lang="scss" scoped>
.common-content{
  min-height: 500px;
}

</style>
